import axios from "axios";
import { serverApi } from "../../../config/Keys";
import {
  CLEAR_ERRORS,
  CLEAR_LOADER,
  SET_LOADER,
  SET_LOADER_SECONDARY,
  SET_ONLINE_COUNTRY,
  SET_ONLINE_STATE,
  SET_ONLINE_CITY,
  SET_ONLINE_OFFER_RESTAURANT,
  SET_ONLINE_OFFER_SELECTED_RESTAURANT,
} from "../../types";
import { setErrors } from "../errorActions";
import Alert from "react-s-alert";

/********************************
 * @DESC SUPER ADMIN GET COUNTRY
 *******************************/
export const super_admin_get_country =
  (token, onSuccess) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      let response = await axios.get(`${serverApi}/filter-restaurant`, {
        headers: {
          Authorization: token,
        },
      });
      if (response.status === 200) {
        let filteredData = response?.data?.restaurantresponse.filter(
          (item, index) => {
            return (
              item?.restaurant_name !== undefined &&
              item?.restaurant_name !== null &&
              item?.restaurant_name !== ""
            );
          }
        );
        dispatch({
          type: SET_ONLINE_COUNTRY,
          payload: response?.data?.countryArray,
        });
        dispatch({
          type: SET_ONLINE_CITY,
          payload: [],
        });
        dispatch({
          type: SET_ONLINE_OFFER_RESTAURANT,
          payload: filteredData && filteredData,
        });
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/********************************
 * @DESC SUPER ADMIN GET STATE
 *******************************/
export const super_admin_get_state =
  (token, formData, onSuccess) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      let response = await axios.get(
        `${serverApi}/filter-restaurant?filterByCountry=true&country=${formData}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (response.status === 200) {
        dispatch({
          type: SET_ONLINE_STATE,
          payload: response?.data?.stateArray,
        });
        dispatch({
          type: SET_ONLINE_OFFER_RESTAURANT,
          payload: response?.data?.restaurantresponse,
        });
        dispatch({
          type: SET_ONLINE_CITY,
          payload: [],
        });
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/********************************
 * @DESC SUPER ADMIN GET CITY
 *******************************/
export const super_admin_get_city =
  (token, country, state, onSuccess) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER_SECONDARY });
      let response = await axios.get(
        `${serverApi}/filter-restaurant?filterByState=true&country=${country}&state=${state}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (response.status === 200) {
        dispatch({
          type: SET_ONLINE_CITY,
          payload: response?.data?.cityArray,
        });
        dispatch({
          type: SET_ONLINE_OFFER_RESTAURANT,
          payload: response?.data?.restaurantresponse,
        });
        dispatch({ type: CLEAR_LOADER });
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/****************************************
 * @DESC SUPER ADMIN GET RESTAURANT LIST
 ***************************************/
export const super_admin_get_restaurant_list =
  (token, country, state, city, onSuccess) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER_SECONDARY });
      let response = await axios.get(
        `${serverApi}/filter-restaurant?filterByCity=true&country=${country}&state=${state}&city=${city}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (response.status === 200) {
        dispatch({
          type: SET_ONLINE_OFFER_RESTAURANT,
          payload: response?.data?.restaurantresponse,
        });
        dispatch({ type: CLEAR_LOADER });
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/************************************************************
 * @DESC SUPER ADMIN GET PERTICULAR SELECYED RESTAURANT LIST
 ************************************************************/
export const super_admin_get_selected_restaurant_list =
  (token, offerId, onSuccess) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER_SECONDARY });
      let response = await axios.get(`${serverApi}/offer-history/${offerId}`, {
        headers: {
          Authorization: token,
        },
      });
      if (response.status === 200) {
        dispatch({
          type: SET_ONLINE_OFFER_SELECTED_RESTAURANT,
          payload: response?.data,
        });
        dispatch({ type: CLEAR_LOADER });
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
